import React, { useEffect, useState } from "react";
import { Image } from "antd";
import { fallBackImage } from "../utils/utilsFunctions";

export const LocalImage = ({ file, style }) => {
  const [imageUrl, setImageUrl] = useState<any>(null);
  useEffect(() => {
    if (!file) {
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setImageUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return (
    <Image src={imageUrl || fallBackImage} alt="Image" style={{ ...style }} />
  );
};
